import api from './axios';

export const bannersAPI = {
  /**
   * GET /api/admin/banners
   */
  getList: () => api.get('/admin/banners'),

  /**
   * POST /api/admin/banners  (multipart/form-data)
   * @param {FormData} formData  — title, image, is_active
   */
  add: (formData) =>
    api.post('/admin/banners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /**
   * DELETE /api/admin/banners/{id}
   */
  remove: (id) => api.delete(`/admin/banners/${id}`),
};
